var defaultValueToDisplayText = require("../../../shared/defaultValueToDisplayText");
var module = angular.module('octopusApp.library');

module.controller('VariableSetEditController', function ($scope, $timeout, $stateParams, $state, $location, busy, pageTitle,
                                                         templateParameterModal, octopusRepository, unsavedChanges, scopeValuesToScopeOptionsConverter) {
    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var lvsId = $stateParams["id"];

    $scope.lvs = null;
    $scope.vs = null;
    $scope.variableTemplates = [];
    $scope.tab = 'values';
    $scope.changeTab = changeTab;
    $scope.templateEditor = null;
    $scope.save = save;
    $scope.defaultValueToDisplayText = defaultValueToDisplayText;

    $scope.$on("variableEditor:changesApplied", function (e, vs) {
        isSaving.promise(octopusRepository.Variables.modify(vs).then(function () {
            unsavedChanges.saved();
            $state.reload();
        }));
    });

    $scope.$on("variableEditor:dirty", function (e, vs) {
        unsavedChanges.unsaved();
    });

    $scope.$on("variableEditor:clean", function (e, vs) {
        unsavedChanges.saved();
    });

    function init() {
        if (lvsId) {
            isLoading.promise(octopusRepository.LibraryVariableSets.get(lvsId).then(function (lvs) {
                $scope.templateEditor = templateParameterModal.create(lvs.Templates, {
                    name: 'Library Variable Template',
                    isTemplate: true,
                    requiredPermission: 'VariableEdit'
                });
                isLoading.promise(octopusRepository.Variables.get(lvs.VariableSetId).then(function (vs) {
                    $scope.lvs = lvs;
                    pageTitle(lvs.Name);

                    $scope.vs = vs;

                    $scope.variableEditorOptions = {
                        variableSet: vs,
                        scopeOptions: scopeValuesToScopeOptionsConverter(vs.ScopeValues),
                        canEdit: true,
                        canScopeToTenantTags: true,
                        canScopeToSteps: false
                    };

                    $timeout(function () {
                        $scope.showVariableEditor = true;
                    }, 100);
                }));
            }));
        } else {
            $scope.lvs = {};
            pageTitle('New Variable Set');
        }
    }

    function changeTab(v) {
        $scope.tab = v;
    }

    function save() {
        if ($scope.lvs.Id) {
            isSaving.promise(octopusRepository.LibraryVariableSets.modify($scope.lvs).then(function (lvs) {
                // ? $scope.lvsForm.$setPristine();
                if (unsavedChanges.hasUnsavedChanges()) {
                    $scope.$broadcast("variableEditor:applyChanges", $scope.vs);
                } else {
                    unsavedChanges.saved();
                    $state.reload();  // Until $setPristine() likes me
                }
            }));
        } else {
            isSaving.promise(octopusRepository.LibraryVariableSets.create($scope.lvs).then(function (lvs) {
                unsavedChanges.saved();
                $location.path('/library/variables/' + lvs.Id);
            }));
        }
    }

    init();
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/library/variables/controllers/variable_set_edit_controller.js
// module id = 8901828788842111
// module chunks = 1